var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ic_ShowProfPics_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_ShowProfPics_",
    "data-name": "ic_ShowProfPics ",
    clipPath: "url(#clip-ic_ShowProfPics_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy_Url",
    "data-name": "Copy Url",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 22,
    height: 22,
    transform: "translate(0)",
    fill: "#8bc400",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye_icon_disable",
    transform: "translate(-11.15 -18.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 18,
    height: 11,
    rx: 5,
    transform: "translate(14.15 24.5)",
    fill: "#8bc500"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(20.347 28.856)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M27.4,28.9c-4.853,0-8.06,4.772-9,6.384.908,1.58,4.115,6.384,9,6.384,4.853,0,8.06-4.772,9-6.384C35.456,33.7,32.249,28.9,27.4,28.9Zm0,10.63c-2.015,0-3.661-1.909-3.661-4.245s1.646-4.245,3.661-4.245,3.661,1.909,3.661,4.245S29.411,39.53,27.4,39.53Z",
    transform: "translate(-5.159 -4.554)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M40.809,35.4a3.609,3.609,0,1,0,3.609,3.609A3.617,3.617,0,0,0,40.809,35.4Zm0,5.427a1.818,1.818,0,1,1,1.818-1.818A1.815,1.815,0,0,1,40.809,40.827Z",
    transform: "translate(-18.186 -8.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M32.946,29.319c-.169-.282-4-6.819-10.849-6.819s-10.623,6.537-10.82,6.819a.865.865,0,0,0,0,.9c.169.282,4,6.819,10.849,6.819s10.651-6.565,10.849-6.819A.811.811,0,0,0,32.946,29.319Zm-10.82,5.917c-4.818,0-8-4.086-8.932-5.467.9-1.353,4.086-5.467,8.932-5.467,4.818,0,8,4.086,8.932,5.467C30.128,31.151,26.944,35.236,22.125,35.236Z",
    transform: "translate(0.5 0.5)",
    fill: "#8bc400",
    stroke: "#8bc500",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.76293b8236f7989a2522b6dbfb144ce0.svg";
export { ForwardRef as ReactComponent };